import PropTypes from 'prop-types';
import React from 'react';
import { I18n } from 'react-redux-i18n';
import classNames from 'classnames';
import { Table, TableBody, TableCell, TableHead, TableRow, Checkbox, Button } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';


import AddCircleIcon from '@material-ui/icons/AddCircle';
import EnhancedTableToolbar from './EnhancedTableToolbar';
import Pagination from './Pagination';

class MsTable extends React.Component {

  static propTypes = {

    data: PropTypes.any,
    tableDef: PropTypes.any,
    entryKey: PropTypes.string,
    multiSelectable: PropTypes.bool,
    selectable: PropTypes.bool,
    stripedRows: PropTypes.bool,
    onSelectionChange: PropTypes.func,
    paginate: PropTypes.bool,
    onPaginate: PropTypes.func,
    toolbar: PropTypes.bool,
    handleEditClick: PropTypes.func,
    handleDeleteClick: PropTypes.func,
    handleCreateClick: PropTypes.func,
    onSwitchChange: PropTypes.func,
    renderCreateButton: PropTypes.any,
    clearSelectionAfterDelete: PropTypes.bool,
  };

  static defaultProps = {

    multiSelectable: false,
    selectable: true,
    stripedRows: true,
    onSelectionChange: selection => console.log(selection),
    paginate: false,
    page: 1,
    pageSize: 10,
    onPaginate: () => console.log('paginate!'),
    toolbar: false,
    handleEditClick: () => console.log('edit!'),
    handleDeleteClick: () => console.log('delete!'),
    handleCreateClick: () => console.log('create!'),
    onSwitchChange: (event, value) => console.log(value),
    renderCreateButton: true,
    clearSelectionAfterDelete: false,

  };

  constructor(props) {

    super(props);

    this.state = {
      selected: {},
      totalPages: 0,
      allRowsSelected: false,
    };

    this.shouldRenderTable = this.shouldRenderTable.bind(this);
    this.handleRowSelection = this.handleRowSelection.bind(this);
    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.afterDeleteCallback = this.afterDeleteCallback.bind(this);

  }

  shouldRenderTable = () => this.props.data
    && this.props.data
    && this.props.data.length > 0

  afterDeleteCallback = (val) => {

    this.props.handleDeleteClick(val);
    if (this.props.clearSelectionAfterDelete)
      this.setState({ selected: {} });

  }

  cleanSelection = (selected, data, entryKey) => data
    .map(entry => entry[entryKey])
    .forEach(key => delete selected[key]);

  handleRowSelection(event, selectedRow) {


    const { entryKey, data, onSelectionChange, multiSelectable } = this.props;
    const { selected } = this.state;

    if (selectedRow === 'all') {

      this.setState({ allRowsSelected: true });
      data.forEach(entry => (selected[entry[entryKey]] = entry));

    } else if (selectedRow === 'none') {

      this.cleanSelection(selected, data, entryKey);
      this.setState({ allRowsSelected: false });

    } else if (selected[selectedRow[entryKey]]) {

      if (!multiSelectable)
        this.cleanSelection(selected, data, entryKey);
      delete selected[selectedRow[entryKey]];

    } else {

      if (!multiSelectable)
        this.cleanSelection(selected, data, entryKey);
      selected[selectedRow[entryKey]] = selectedRow;

    }

    this.setState({ selected });
    onSelectionChange(selected);

  }

  handleSwitchChange(event, row) {

    const { onSwitchChange } = this.props;

    onSwitchChange(row);

  }

  render() {

    const {
      data,
      classes,
      entryKey,
      tableDef,
      stripedRows,
      selectable,
      multiSelectable,
      paginate,
      onPaginate,
      toolbar,
      handleEditClick,
      handleCreateClick,
      renderCreateButton,
    } = this.props;
    const { selected, allRowsSelected, numSelected, rowCount } = this.state;

    return (
      <div>
        {
          this.shouldRenderTable() && <div>
            {/* {
              toolbar && <EnhancedTableToolbar
                data={data}
                selected={Object.keys(selected).map(key => selected[key])}
                handleEditClick={handleEditClick}
                handleDeleteClick={this.afterDeleteCallback}
                handleCreateClick={handleCreateClick}
                renderCreateButton={renderCreateButton}
              />
            } */}
            <Table>
              <TableHead>
                <TableRow>

                  {(multiSelectable || selectable) &&
                  <TableCell padding="checkbox">

                    <Checkbox
                      disabled={!multiSelectable} style={{ visibility: multiSelectable ? 'visible' : 'hidden' }} onChange={(ev, checked) => this.handleRowSelection(ev, checked ? 'all' : 'none')}
                    />

                  </TableCell>
                  }


                  {tableDef.map((col) => {

                    const { label } = col;

                    return (

                      <TableCell key={label}>
                        {I18n.t(`fields.${label}`)}
                      </TableCell>
                    );

                  })
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  data.map(entry => (<TableRow
                    key={entry[entryKey]}
                    selected={!!(selected[entry[entryKey]])}
                  >
                    {selectable &&
                      <TableCell padding="checkbox">
                        <Checkbox onChange={(ev, checked) => this.handleRowSelection(ev, entry)} checked={!!(selected[entry[entryKey]])} />
                      </TableCell>
                    }
                    {
                      tableDef.map((col) => {


                        const { name, normalizer, switchable } = col;

                        return (<TableCell key={entry[entryKey]}>

                          {normalizer && normalizer(entry[name]) }
                          {switchable && <FormControlLabel
                            control={
                              <Switch
                                checked={entry[name]}
                                onChange={(ev, checked) => this.handleSwitchChange(ev, entry)}
                                value={[entry[name]]}
                                color="primary"
                              />
                            }
                            label={entry[name] === true ? I18n.t('application.yes') : I18n.t('application.no')}
                          />}
                          { !normalizer && !switchable && entry[name]}
                        </TableCell>);

                      })
                    }
                  </TableRow>))
                }
              </TableBody>
            </Table>
            {
              paginate && <Pagination
                onPaginate={(page) => {

                  this.setState({ allRowsSelected: false });
                  onPaginate(page);

                }}
                data={data}
              />
            }
          </div>
        }
        {
          this.shouldRenderTable() || <div>
            {/* <EnhancedTableToolbar
                data={data}
                selected={Object.keys(selected).map(key => selected[key])}
                handleCreateClick={handleCreateClick}
                renderCreateButton={renderCreateButton}
              /> */}
          </div>
        }

      </div>
    );

  }

}

export default MsTable;



// WEBPACK FOOTER //
// ./src/components/table/MsTable.js